import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export interface IGTMEventLeadForm {
    clickText: InquiryButtonTypeName | string;
    source: GTMEventApplicationSourceSection | string;
    vendorName: string;
    offerName: string;
}

export const gtmEventFormOpen = (
    clickText: InquiryButtonTypeName | string,
    source: GTMEventApplicationSourceSection | string,
    vendorName: string,
    offerName: string
) => {
    const gtmData = {
        event: "form_open",
        event_label: clickText,
        event_category: source,
        event_category2: vendorName,
        event_category3: offerName
    };
    hitGoogleTagManager(gtmData);
};
import {InquiryButtonTypeName} from "../../../constants/inquiry_button_type";
import {GTMEventApplicationSourceSection} from "../../application/types/lead/GTMEvenApplicationSourceSection";
import {hitGoogleTagManager} from "./hit_google_tag_manager";

export interface IGTMEventLeadForm {
    clickText: InquiryButtonTypeName | string;
    source: GTMEventApplicationSourceSection | string;
    vendorName: string;
    offerName: string;
}

export const gtmEventFormOpen = (
    clickText: InquiryButtonTypeName | string,
    source: GTMEventApplicationSourceSection | string,
    vendorName: string,
    offerName: string
) => {
    const gtmData = {
        event: "form_open",
        event_label: clickText,
        event_category: source,
        event_category2: vendorName,
        event_category3: offerName
    };
    hitGoogleTagManager(gtmData);
};
